import { IntegrationKind } from "@redotech/redo-integrations-core";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { contentGenerationContextToolSchema } from "@redotech/redo-model/content-generation-context-tool/content-generation-context-tool-definition";
import {
  MarketingAgent,
  PromptCategory,
  marketingAgentPromptSchema,
} from "@redotech/redo-model/marketing/marketing-agent-prompt/marketing-agent-prompt-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * RPC schema for creating a new marketing agent prompt.
 */
const createMarketingAgentPromptInputSchema_ = z.object({
  agent: createEnum(MarketingAgent),
  promptCategory: createEnum(PromptCategory),
  prompt: z.string().optional(),
  examples: z.string().optional(),
  displayLabel: z.string().min(1, "Display label is required"),
  displayDescription: z.string().optional(),
  contextTools: z.array(contentGenerationContextToolSchema).optional(),
  integrations: z.array(z.enum(IntegrationKind)).optional(),
  goalMarketingAgentPromptId: zExt.objectId().optional(),
  methodMarketingAgentPromptId: zExt.objectId().optional(),
  triggerSchemaType: createEnum(SchemaType).optional(),
  triggerMarketingAgentPromptIds: z.array(zExt.objectId()).optional(),
});
export interface CreateMarketingAgentPromptInput extends z.infer<
  typeof createMarketingAgentPromptInputSchema_
> {}
export const createMarketingAgentPromptInputSchema: z.ZodType<CreateMarketingAgentPromptInput> =
  createMarketingAgentPromptInputSchema_;

export const createMarketingAgentPrompt = {
  name: "createMarketingAgentPrompt" as const,
  input: createMarketingAgentPromptInputSchema,
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    prompt: marketingAgentPromptSchema.optional(),
  }),
};
